import { useCallback, useMemo } from 'react';

import { CONTACTS, COUNTRY_CODES } from 'shared/presentation/constants';
import { useLocale } from 'shared/presentation/contexts';
import {
  buildWhatsappLink,
  buildWhatsappMessage,
} from 'shared/presentation/helpers';

import useEventTracker from './useEventTracker';
import useWhatsappProtocolId from './useWhatsappProtocolId';

export default function useTrackedWhatsappLink(params: {
  event: string;
  message: string;
}) {
  const { language } = useLocale();
  const eventTracker = useEventTracker();
  const { whatsappProtocolId, generateNewProtocolId } = useWhatsappProtocolId();

  const handleTrackEvent = useCallback(() => {
    eventTracker.register(params.event, {
      whatsappProtocolId,
      whatsappMessage: params.message,
      origen: document.referrer,
    });

    generateNewProtocolId();
  }, [
    generateNewProtocolId,
    whatsappProtocolId,
    params.message,
    params.event,
    eventTracker,
  ]);

  const link = useMemo(
    () =>
      buildWhatsappLink({
        countryCode: COUNTRY_CODES[language],
        number: CONTACTS[language],
        language,
        message: buildWhatsappMessage({
          message: params.message,
          protocolId: whatsappProtocolId,
        }),
      }),
    [language, params.message, whatsappProtocolId],
  );

  return {
    onClickLink: handleTrackEvent,
    href: link,
  };
}
